var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { boundMethod } from 'autobind-decorator';
import memoize from 'memoize-one';
import { PureComponent } from 'react';
import { getAvailableCountries } from './api/countries';
export const withAvailableCountries = (Component) => {
    class WithAvailableCountries extends PureComponent {
        constructor() {
            super(...arguments);
            this.state = {
                items: [],
                getItemsAsyncStatus: 'success',
            };
            this.memoizedGetInjectedProps = memoize(this.getInjectedProps).bind(this);
        }
        getItems() {
            this.setState({ getItemsAsyncStatus: 'loading' });
            return getAvailableCountries().then(this.handleQueryResolve, this.handleQueryReject);
        }
        handleQueryResolve(response) {
            const { data: { countries }, } = response;
            const items = countries.sort((a, b) => a.country.localeCompare(b.country));
            this.setState({
                items,
                getItemsAsyncStatus: 'succeeded',
            });
            return response;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        handleQueryReject(error) {
            this.setState({ getItemsAsyncStatus: 'failed' });
            return error;
        }
        getInjectedProps(items, getItemsAsyncStatus) {
            return {
                items,
                getItemsAsyncStatus,
                getItems: this.getItems,
            };
        }
        render() {
            const { items, getItemsAsyncStatus } = this.state;
            return (_jsx(Component, Object.assign({}, this.props, { availableCountries: this.memoizedGetInjectedProps(items, getItemsAsyncStatus) })));
        }
    }
    __decorate([
        boundMethod
    ], WithAvailableCountries.prototype, "getItems", null);
    __decorate([
        boundMethod
    ], WithAvailableCountries.prototype, "handleQueryResolve", null);
    __decorate([
        boundMethod
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ], WithAvailableCountries.prototype, "handleQueryReject", null);
    return WithAvailableCountries;
};
